
























































































































































import axios from 'axios';
import EventBus from '@/eventBus';
import CoModal from '@/components/Organisms/co-modal/CoModal.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoCard from '../../../../components/Molecules/co-card/CoCard.vue';
import CoButton from '../../../../components/Atoms/co-button/CoButton.vue';
import CoSkeleton from '@/components/Atoms/co-skeleton/CoSkeleton.vue';

export default {
    name: 'Stripe',
    components: { CoHeadline, CoText, CoModal, CoCard, CoButton, CoSkeleton },
    data() {
        return {
            status: 0, // 0 not connected, 1 pending, 2 need more data, 3 connected
            applicationFee: null,
            loading: false,
            appFeeloading: false,
            chargesEnabled: false,
            btnLoading: false,
            isStrategyModal: false,
            signUpSettings: {},
        };
    },
    mounted() {
        this.getApplicationFee();
        this.getPaymentAccountConnectState();
        this.getSignUpSettings();
        window.addEventListener('message', this.handleMessage);
    },
    beforeDestroy() {
        window.removeEventListener('message', this.handleMessage);
    },
    methods: {
        handleMessage(event) {
            if (event.data.type === 'WINDOW_CLOSE') {
                this.signUpSettings.signUpStrategy = event.data.data.strategy;
                if (event.data.data.strategy !== 'approval') {
                    this.getPaymentAccountConnectLink();
                } else {
                    EventBus.$emit('Error', {
                        Message: this.$t('messages.signupStrategyChangeRequired'),
                        Details: '',
                    });
                }
            }
        },
        getApplicationFee() {
            this.appFeeloading = true;
            axios({
                method: 'GET',
                url: '/admin/space/settings',
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data && response.data.ApplicationFee) {
                        this.applicationFee = response.data.ApplicationFee;
                    }
                })
                .catch((error) => {
                    if (console && console.warn) console.warn('could not get application fee for this space');
                })
                .finally(() => {
                    this.appFeeloading = false;
                });
        },
        addPaymentMethod() {
            return '/admin/setup/signup-strategy?closeAfterSave=true';
        },

        goToSignupStrategies() {
            window.open(this.addPaymentMethod(), '_blank').focus();
        },
        getSignUpSettings() {
            this.$store
                .dispatch('getSignupSettings')
                .then((response) => {
                    this.signUpSettings = response.data;
                })
                .finally(() => {
                    // this.loading = false;
                });
        },
        getPaymentAccountConnectLink() {
            if (this.signUpSettings.signUpStrategy === 'approval') {
                this.isStrategyModal = true;
                this.$refs.settingsChangeNeeded.show();
            } else {
                this.connectStripe();
            }
        },
        connectStripe() {
            this.btnLoading = true;
            axios({
                method: 'GET',
                url: '/admin/payment/stripe/account-link',
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data && response.data.URL) {
                        window.location = response.data.URL;
                    } else {
                        EventBus.$emit('Error', {
                            Message: this.$t('messages.stripeConnectFailed'),
                            Details: '',
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                    EventBus.$emit('Error', {
                        Message: this.$t('messages.stripeConnectFailed'),
                        Details: '',
                    });
                })
                .finally(() => {
                    this.btnLoading = false;
                });
        },
        getPaymentAccountConnectState() {
            this.loading = true;
            axios({
                method: 'GET',
                url: '/admin/payment/stripe/account-state',
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data) {
                        this.chargesEnabled = response.data.ChargesEnabled;
                        if (this.chargesEnabled) {
                            this.status = 3;
                        }
                    }
                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;
                });
        },
        navigateToStripeDashboard() {
            // open stripe dashboard in new tab
            window.open('https://dashboard.stripe.com/dashboard', '_blank').focus();
        },
    },
};
